module.exports = __webpack_public_path__ + "static/media/bg-web.b5b422f1.png";